export class CustomField {
  public key: string;
  public value: any;

  constructor() {
    this.value = {};
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/custom-field.ts